/* unplugin-vue-components disabled */import script from "./IntegralHotelRoomConfigure.vue?vue&type=script&setup=true&lang=js"
export * from "./IntegralHotelRoomConfigure.vue?vue&type=script&setup=true&lang=js"

import "./IntegralHotelRoomConfigure.vue?vue&type=style&index=0&id=2bc4cd85&lang=scss"
import "./IntegralHotelRoomConfigure.vue?vue&type=style&index=1&id=2bc4cd85&lang=scss&scoped=true"
import "./IntegralHotelRoomConfigure.vue?vue&type=style&index=2&id=2bc4cd85&lang=scss"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bc4cd85"]])

export default __exports__